import { ref as i, computed as v, useId as _, watchEffect as g, createElementBlock as s, openBlock as l, createElementVNode as o, createCommentVNode as u, unref as m, normalizeClass as y, toDisplayString as h } from "vue";
import { themeProp as B } from "../../../composables/useTheme.js";
/* empty css                   */
const E = { class: "ds-margin-bottom-12" }, q = ["for"], w = {
  class: "ds-form-checkbox__icon",
  width: "16",
  height: "16"
}, C = {
  key: 0,
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, M = ["id", "name", "checked", "disabled"], j = { class: "ds-form-checkbox__label ds-text ds-padding-left-12" }, S = {
  key: 0,
  class: "ds-text-small ds-margin-y-3 ds-color-red",
  "data-j-error": ""
}, V = /* @__PURE__ */ Object.assign({
  name: "DsFormCheckbox",
  inheritAttrs: !1
}, {
  __name: "form-checkbox",
  props: {
    ...B,
    /**
     * Checkbox's label text
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Checkbox's name
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Checkbox's value, optional
     */
    value: {
      type: Boolean,
      default: !1
    },
    /**
     * Checkbox's error message text, optional
     */
    errorMessage: {
      type: String,
      default: ""
    },
    /**
     * Checkbox is required, optional
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Checkbox has error, force error state, optional
     */
    hasError: {
      type: Boolean,
      default: !1
    },
    /**
     * Checkbox disabled state, optional
     */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["value"],
  setup(t, { emit: f }) {
    const k = f, r = t, e = i(r.value), n = i(r.hasError), b = v(() => e.value ? "enter" : "leave"), d = _();
    g(() => {
      e.value = r.value, n.value = r.hasError;
    });
    function p(c) {
      e.value = c.target.checked, k("value", e.value);
    }
    function x() {
      r.required && (n.value = !e.value);
    }
    return (c, a) => (l(), s("div", E, [
      o("label", {
        class: y(["ds-form-checkbox", [
          `ds-form-checkbox--${c.theme}`,
          `ds-form-checkbox--animation-${b.value}`,
          { "ds-form-checkbox--checked": e.value },
          { "ds-form-checkbox--disabled": t.disabled }
        ]]),
        for: `checkbox-${m(d)}`
      }, [
        (l(), s("svg", w, [
          a[1] || (a[1] = o("rect", {
            class: "ds-form-checkbox__icon-square",
            width: "14",
            height: "14",
            rx: "2",
            transform: "matrix(1 0 0 -1 1 15)",
            fill: "transparent",
            stroke: "currentColor",
            "stroke-width": "2"
          }, null, -1)),
          e.value ? (l(), s("g", C, a[0] || (a[0] = [
            o("path", {
              class: "ds-form-checkbox__icon-checkmark",
              d: "M11 6L7 10"
            }, null, -1),
            o("path", {
              class: "ds-form-checkbox__icon-checkmark",
              d: "M5 8L7 10"
            }, null, -1)
          ]))) : u("", !0)
        ])),
        o("input", {
          id: `checkbox-${m(d)}`,
          type: "checkbox",
          class: "ds-form-checkbox__input",
          name: t.name,
          checked: e.value,
          disabled: t.disabled,
          "data-j-input": "",
          onInput: p,
          onBlur: x
        }, null, 40, M),
        o("span", j, h(t.label), 1)
      ], 10, q),
      n.value ? (l(), s("p", S, h(t.errorMessage), 1)) : u("", !0)
    ]));
  }
});
export {
  V as default
};
